class Accordion {
  constructor() {
    this.selectors = {
      section: '.js-accordion',
      button: '.js-accordion-button',
      content: '.js-accordion-content',
      item: '.js-accordion-item',
    };

    this.sections = document.querySelectorAll(this.selectors.section);

    if (!this.sections.length) {
      return;
    }

    this.DOM = {
      buttons: document.querySelectorAll(this.selectors.button),
    };

    this.classes = {
      active: 'is-active',
    };

    this.init();
  }

  init() {
    this.DOM.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest(this.selectors.item);
        const content = item.querySelector(this.selectors.content);

        const activeItem = document.querySelector(
          `${this.selectors.item}.${this.classes.active}`,
        );

        if (
          activeItem &&
          activeItem.getAttribute('id') !== item.getAttribute('id')
        ) {
          activeItem.querySelector(this.selectors.content).style.maxHeight =
            null;
          activeItem.classList.remove(this.classes.active);
          activeItem
            .querySelector(this.selectors.button)
            .setAttribute('aria-expanded', false);
        }

        if (item.classList.contains(this.classes.active)) {
          content.style.maxHeight = null;
          item.classList.remove(this.classes.active);
          button.setAttribute('aria-expanded', false);
        } else {
          content.style.maxHeight = `${content.scrollHeight}px`;
          item.classList.add(this.classes.active);
          button.setAttribute('aria-expanded', true);
        }
      });
    });
  }
}

export default new Accordion();
